import { useEffect, useState } from "react";
import { useDebounce } from "../../../../../hooks/useDebounce";
import { producaov2 } from "../../../../../services/apis";
import { COURSE_EXTENSION_ID, FORMATION_EXTENSION_ID, MBA_EXTENSION_ID, VOITTO_PRO_EXTENSION_COURSE_ID } from "../../../../../constants";

export default function useProducts({ search = '' }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const debouncedSearch = useDebounce(search, search ? 500 : 0);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);

        const response = await producaov2.get('/cursos-simplelist', {
          params: {
            limit: 20,
            search: debouncedSearch,
            excludeIDs: [COURSE_EXTENSION_ID, FORMATION_EXTENSION_ID, MBA_EXTENSION_ID, VOITTO_PRO_EXTENSION_COURSE_ID]
          }
        });

        setData(response.data);
      } catch(error) {
        setData([]);
      } finally {
        setLoading(false);
      }
    }

    getData();
  }, [debouncedSearch]);

  useEffect(() => {
    if(!loading) {
      setLoading(true);
    }
  }, [search]);

  return {
    data,
    loading
  }
}